import Donation from './models'

export default Donation
